import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            关于51cg平台最常被问到的问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {item.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index
                    ? "bg-primary-500 text-background-50 rotate-180"
                    : "bg-background-100 text-foreground-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <div className="pt-1 border-t border-background-200">
                    <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                      {item.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}